import { render, staticRenderFns } from "./EditShiftNotesModal.vue?vue&type=template&id=ab5535b6&scoped=true"
import script from "./EditShiftNotesModal.vue?vue&type=script&lang=js"
export * from "./EditShiftNotesModal.vue?vue&type=script&lang=js"
import style0 from "./EditShiftNotesModal.vue?vue&type=style&index=0&id=ab5535b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5535b6",
  null
  
)

export default component.exports